var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-modal", { attrs: { id: "paymentModal", "hide-footer": true } }, [
    _vm.transactionData
      ? _c(
          "div",
          { attrs: { id: "paymentForm" } },
          [
            _c(
              "div",
              { staticClass: "formTitle" },
              [
                _c("svg-image", { attrs: { image: "iconPay" } }),
                _vm._v(" "),
                _c("h5", [_vm._v(_vm._s(_vm.$t("payment.head")))]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "invoiceDetails text-center" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm.$t("payment.currency")) +
                    " " +
                    _vm._s(_vm.transactionData.data.trnsAmount)
                ),
              ]),
              _vm._v(" "),
              _c("h6", [
                _vm._v(
                  _vm._s(_vm.$t("payment.code")) +
                    ": " +
                    _vm._s(_vm.transactionData.data.trnsRefId)
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("payment.limit")) + ": "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm._f("moment")(
                        _vm.transactionData.data.trnsExpiredTime,
                        "D MMMM YYYY HH:mm"
                      )
                    ) + " WIB (GMT+7)"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("alert", { attrs: { status: _vm.status } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "couponCode" },
              [
                _c(
                  "b-input-group",
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "coupon",
                        type: "text",
                        required: "",
                        placeholder: _vm.$t("payment.code"),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-button",
                          { attrs: { variant: "primary" } },
                          [
                            _vm.applyingCoupon
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.$t("payment.apply"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "groupLabel text-center" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("payment.pay")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "paymentMethod" }, [
              _c(
                "a",
                {
                  attrs: { href: "", "payment-id": "6", id: "snap_cc_bri" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.doPay(22)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-pay btn-cc" },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("payment.paycc")),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "arrow", attrs: { sm: "auto" } },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "arrow-right",
                                  "font-scale": "3",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.validVA
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: "",
                        "payment-id": "10",
                        id: "virtual_account_jateng",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.doPay(10)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "btn-pay btn-bt" },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("payment.paybt")),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { staticClass: "arrow", attrs: { sm: "auto" } },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "arrow-right",
                                      "font-scale": "3",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.validVA
              ? _c("div", { staticClass: "bankTransferDetails" }, [
                  _c("div", { staticClass: "groupLabel text-center" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("payment.trans")))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "banktransferDetails text-center" },
                    [
                      _c("img", {
                        staticClass: "bankJateng",
                        attrs: {
                          src: "https://assets.heartwork.co.id/bormar/bankjateng.svg",
                        },
                      }),
                      _vm._v(" "),
                      _c("h6", [_vm._v(_vm._s(_vm.$t("payment.va")))]),
                      _vm._v(" "),
                      _c("h4", [_vm._v(_vm._s(_vm.validVA.jtvaVANumber))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("payment.swift")) + ": "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.theswiftcodes.com/indonesia/pdjgidja/",
                              target: "_blank",
                            },
                          },
                          [_vm._v("PDJGIDJA")]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { role: "tablist" } },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            { attrs: { "header-tag": "header", role: "tab" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.accordion-bj",
                                      modifiers: { "accordion-bj": true },
                                    },
                                  ],
                                  attrs: { block: "", href: "#" },
                                },
                                [
                                  _c("img", {
                                    staticClass: "atm-logo",
                                    attrs: {
                                      src: "https://assets.heartwork.co.id/bormar/atm-bankjateng.png",
                                    },
                                  }),
                                  _vm._v(" ATM Bank Jateng"),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "accordion-bj",
                                visible: "",
                                accordion: "my-accordion",
                                role: "tabpanel",
                              },
                            },
                            [
                              _c("b-card-body", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("payment.atmbj")),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            { attrs: { "header-tag": "header", role: "tab" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.accordion-ab",
                                      modifiers: { "accordion-ab": true },
                                    },
                                  ],
                                  attrs: { block: "", href: "#" },
                                },
                                [
                                  _c("img", {
                                    staticClass: "atm-logo",
                                    attrs: {
                                      src: "https://assets.heartwork.co.id/bormar/atmbersama.png",
                                    },
                                  }),
                                  _vm._v(" ATM Bersama"),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "accordion-ab",
                                visible: "",
                                accordion: "my-accordion",
                                role: "tabpanel",
                              },
                            },
                            [
                              _c("b-card-body", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("payment.atmb")),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-header",
                            { attrs: { "header-tag": "header", role: "tab" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle.accordion-bp",
                                      modifiers: { "accordion-bp": true },
                                    },
                                  ],
                                  attrs: { block: "", href: "#" },
                                },
                                [
                                  _c("img", {
                                    staticClass: "atm-logo",
                                    attrs: {
                                      src: "https://assets.heartwork.co.id/bormar/atmprima.png",
                                    },
                                  }),
                                  _vm._v(" ATM BCA/Prima"),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "accordion-bp",
                                visible: "",
                                accordion: "my-accordion",
                                role: "tabpanel",
                              },
                            },
                            [
                              _c("b-card-body", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("payment.atmp")),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/PaymentModal.vue